import React, { FC } from 'react';
import { Entry } from 'contentful';
import { TypeLink_external, TypeLink_internal } from '@/core/generated-types';
import { DynamicComponent, ExternalLink, InternalLink } from '@/components';

interface SitemapColumnProps {
  components: Entry<Record<string, any>>[] | undefined;
}

const SitemapColumn: FC<SitemapColumnProps> = ({ components }) => {
  if (!components) {
    return null;
  }

  return (
    <div>
      {components?.map((component, index) => (
        <div
          key={`${component.sys.id}-${index}`}
          className="top-level-list mt-6 border-t-2 border-grey-midtone"
        >
          {component?.sys?.contentType?.sys?.id === 'link_internal' ? (
            <div className=" my-6">
              <InternalLink
                link={component as TypeLink_internal}
                classes="text-indigo"
              />
            </div>
          ) : component?.sys?.contentType?.sys?.id === 'link_external' ? (
            <div className=" my-6">
              <ExternalLink
                link={component as TypeLink_external}
                classes="text-indigo"
              />
            </div>
          ) : (
            <div className="leading-8">
              <DynamicComponent component={component} nestingLevel={1} />
            </div>
          )}
        </div>
      ))}
      <div className="lg:border-b-2 lg:border-grey-midtone" />
    </div>
  );
};

export default React.memo(SitemapColumn);
